(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js');

  /* ---------- En-tête : ombre quand on fait défiler ---------- */
  var header = document.querySelector('header.site');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Apparition des contenus au défilement (une seule fois) ---------- */
  var groups = document.querySelectorAll('[data-reveal]');
  if (!reduce && 'IntersectionObserver' in window && groups.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var items = en.target.querySelectorAll('[data-reveal-item]');
        if (!items.length) items = [en.target];
        Array.prototype.forEach.call(items, function (el, i) {
          el.style.transitionDelay = Math.min(i, 8) * 60 + 'ms';
        });
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    groups.forEach(function (g) { g.classList.add('reveal-ready'); io.observe(g); });
  }

  /* ---------- Vitrine de l'accueil : pile de produits qui défile ---------- */
  document.querySelectorAll('[data-deck]').forEach(function (deck) {
    var cards = Array.prototype.slice.call(deck.querySelectorAll('[data-deck-card]'));
    var dots = deck.parentNode.querySelectorAll('[data-deck-dot]');
    if (cards.length < 2) return;
    var order = cards.map(function (_, i) { return i; });
    var timer = null;
    function paint() {
      order.forEach(function (cardIdx, pos) {
        var c = cards[cardIdx];
        c.setAttribute('data-pos', pos < 4 ? pos : 'hidden');
        c.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        c.tabIndex = pos === 0 ? 0 : -1;
        var link = c.querySelector('a');
        if (link) link.tabIndex = pos === 0 ? 0 : -1;
      });
      Array.prototype.forEach.call(dots, function (d, i) {
        d.setAttribute('aria-current', i === order[0] ? 'true' : 'false');
      });
    }
    function next() { order.push(order.shift()); paint(); }
    function goTo(i) { while (order[0] !== i) order.push(order.shift()); paint(); }
    function start() { if (!reduce && !timer) timer = setInterval(next, 3800); }
    function stop() { clearInterval(timer); timer = null; }
    Array.prototype.forEach.call(dots, function (d, i) {
      d.addEventListener('click', function () { stop(); goTo(i); start(); });
    });
    deck.addEventListener('mouseenter', stop);
    deck.addEventListener('mouseleave', start);
    deck.addEventListener('focusin', stop);
    deck.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    paint();
    start();
  });

  /* ---------- Galerie produit : fondu entre les photos ---------- */
  var mainWrap = document.querySelector('[data-main-img]');
  if (mainWrap) {
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        mainWrap.classList.remove('is-swapping');
        void mainWrap.offsetWidth;
        mainWrap.classList.add('is-swapping');
      });
    });
  }

  /* ---------- Barre d'achat collante sur la fiche produit ---------- */
  var buyRow = document.querySelector('.buy-row');
  var sticky = document.querySelector('[data-sticky-buy]');
  if (buyRow && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !e.isIntersecting && below);
    }).observe(buyRow);
    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    var mainBtn = document.querySelector('[data-add]');
    var priceEl = document.querySelector('[data-price]');
    var stickyPrice = sticky.querySelector('[data-sticky-price]');
    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.getElementById('ProductForm');
        if (form && form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
      });
      var sync = function () {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.disabled ? 'Épuisé' : 'Ajouter au panier';
        if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
      };
      var sel = document.querySelector('[data-variant-select]');
      if (sel) sel.addEventListener('change', function () { setTimeout(sync, 0); });
      sync();
    }
  }

  /* ---------- Panier latéral (ajout sans recharger la page) ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var badge = document.getElementById('cart-count');
  var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  function money(cents) { return fmt.format(cents / 100); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('drawer-open');
    var close = drawer.querySelector('[data-cart-close]');
    if (close) setTimeout(function () { close.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(cart) {
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump');
    }
    if (!drawer) return;
    var list = drawer.querySelector('[data-cart-items]');
    var total = drawer.querySelector('[data-cart-total]');
    var count = drawer.querySelector('[data-cart-count]');
    var empty = drawer.querySelector('[data-cart-empty]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var ship = drawer.querySelector('[data-ship]');
    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = money(cart.total_price);
    var has = cart.item_count > 0;
    if (empty) empty.hidden = has;
    if (foot) foot.hidden = !has;
    if (list) {
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="z-item__var">' + esc(it.variant_title) + '</span>' : '';
        return '<li class="z-item" data-key="' + esc(it.key) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="z-item__ph"></span>') +
          '<div class="z-item__info"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="z-qty"><button type="button" data-qty="-1" aria-label="Retirer un article">−</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-qty="1" aria-label="Ajouter un article">+</button></div></div>' +
          '<div class="z-item__price">' + money(it.final_line_price) +
          '<button type="button" class="z-item__rm" data-remove>Retirer</button></div></li>';
      }).join('');
    }
    if (ship) {
      var threshold = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
      if (threshold > 0) {
        var left = threshold - cart.total_price;
        var pct = Math.max(0, Math.min(100, cart.total_price / threshold * 100));
        ship.hidden = !has;
        ship.querySelector('[data-ship-text]').textContent = left > 0
          ? 'Plus que ' + money(left) + ' pour la livraison offerte'
          : 'La livraison est offerte';
        ship.classList.toggle('is-done', left <= 0);
        var bar = ship.querySelector('[data-ship-bar]');
        requestAnimationFrame(function () { bar.style.width = pct + '%'; });
      } else {
        ship.hidden = true;
      }
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(key, qty) {
    if (drawer) drawer.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart)
      .finally(function () { if (drawer) drawer.classList.remove('is-busy'); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      var line = e.target.closest('.z-item');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.z-qty span');
      var q = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      var step = e.target.closest('[data-qty]');
      if (step) changeLine(key, Math.max(0, q + parseInt(step.getAttribute('data-qty'), 10)));
      if (e.target.closest('[data-remove]')) changeLine(key, 0);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
    document.querySelectorAll('a[href="/cart"], a.cart-wrap').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        refresh().then(openDrawer);
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!drawer || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    if (submitter && submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], .add');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    }).then(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = 'Ajouté'; }
      return refresh().then(openDrawer);
    }).catch(function (err) {
      if (btn) { btn.classList.remove('is-loading'); btn.textContent = (err && err.description) ? 'Stock insuffisant' : 'Réessayer'; }
    }).finally(function () {
      if (!btn) return;
      setTimeout(function () {
        btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = label;
      }, 2000);
    });
  });
})();
